import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import Chart from 'chart.js';
import moment from 'moment';
import { AppConfigService } from '../../services/app-config.service';
import { ReportService } from '../../services/report.service';
import pattern from 'patternomaly';
import { WeatherForecastService } from '../../services/weather-forecast.service';
declare const testRadar: any;

@Component({
  selector: 'app-weather',
  templateUrl: './weather.component.html',
  styleUrls: ['./weather.component.scss']
})
export class WeatherComponent implements OnInit {
  currentDatetime;
  stateList;
  dataList = [];
  navSwiper;
  swiper;

  constructor(
    private reportService: ReportService,
    private weatherService: WeatherForecastService,
    public appConfig: AppConfigService,
  ) { }

  ngOnInit(): void {
    setInterval(() => { this.currentDatetime = Date.now() }, 1000);
    this.initRadar();
    this.initData();
    setInterval(() => { this.initData() }, 1 * 60 * 60 * 1000); //  one hour load once
  }

  initData() {
    const now = moment();
    const currentYear = now.year();
    const currentMonth = now.month();
    this.stateList = this.appConfig.stateList;
    this.reportService.getReportSummaryByStates(currentYear, currentMonth + 1).subscribe(reportResp => {
      this.dataList = reportResp.data.result;
      console.log(`this.dataList >> ${JSON.stringify(this.dataList)}`);
      this.stateList = this.appConfig.stateList;
      for (const state of this.stateList) {
        const findCurrMonthStateData = this.dataList.find(d => d.stateName.toUpperCase() === state.name
          && d.month === currentMonth + 1 && d.year === currentYear);
        if (findCurrMonthStateData) {
          state.currMonthYield = findCurrMonthStateData.yield;
          state.currMonthCapacity = findCurrMonthStateData.capacity;
        }

        this.weatherService.getWeatherForecast(state.latitude, state.longitude).subscribe(resp => {
          const currentWeather = resp;
          console.log(`resp >> ${JSON.stringify(resp)}`);
          const weather = currentWeather.weather[0];
          state.weather = weather.main;
          state.temperature = currentWeather.main.temp.toFixed(0);
          const hour = moment().hour();
          console.log(`hour >> ${hour}`)
          if (weather.id === 801) {
            if (hour >= 8 && hour <= 18) {
              state.weatherIcon = 'assets/img/cloudy-sun.png';
            } else {
              state.weatherIcon = 'assets/img/cloudy-moon.png';
            }
          } else {
            const findWeather = this.weatherService.WeatherType.find(w => w.name === state.weather);
            if (findWeather) {
              state.weatherIcon = findWeather.img;
            }
          }
        })
      }
    });
  }

  onNavSwiperInit(swiper) {
    this.navSwiper = swiper;
  }

  onSwiper(swiper) {
    this.swiper = swiper;
  }


  initRadar() {
    testRadar();
  }
}
